import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';


import api from '~/services/api';
import { format } from 'date-fns';
import {
    recordFiltering, resetValues, deletePleitoPostoAnexo
} from '~/store/modules/pleitopostoanexo/actions';

import { includes } from 'lodash';


import * as S from './styles';
import { Visibility, VisibilityOff, CloudDownload } from '@material-ui/icons';
import { IconButton, LinearProgress, Box, Typography, } from '@material-ui/core';
import { t, parseDateString } from '~/helpers';
import { closeDialog } from '~/store/modules/dialog/actions';
import { Input, DateTime, InputText, Select, Autocomplete } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import { isEmpty, isNull, difference } from 'lodash';

import { UnidataTable } from '~/components';

import Dropzone from '../components/Dropzone';
import { toast } from 'react-toastify';
import isEqual from 'date-fns/isEqual';

import { ADM } from '~/constants/perfil';
import {  GFE, GFO, GFU, GPP } from '~/constants/perfil';

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}


export default function UploadPleitoPosto({ create, data, close, ...props }) {
    const dispatch = useDispatch();

    const { profile } = useSelector(state => state.user);

    const [isADM, setIsADM] = useState(false)
    const [isVisualizar, setIsVisualizar] = useState(false)

    const reference = useRef(null);
    const redux = useSelector((state) => state.pleitoPostoAnexo);

    const [initials, setInitials] = useState(data)

    const { token } = useSelector(state => state.auth)

    const [dropzoneDisabled, setDropzoneDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [dropFiles, setDropFiles] = useState([])
    const [filesTemp, setFilesTemp] = useState([])
    const [progress, setProgress] = useState(0)
    const [progress2, setProgress2] = useState(0)
    const [showProgressBar, setShowProgressBar] = useState(false)
    const [showProgressBar2, setShowProgressBar2] = useState(false)
    const [cleanList, setCleanList] = useState(false)

    const { glousuariotipo } = useSelector(
        (state) => state.user.profile
      );

      useEffect(() => {

        if (profile.perfcodigo == String(ADM)) {
            setIsADM(true)
        } else if (  includes([ GFE, GFO, GFU, GPP], glousuariotipo) ) {
            setIsVisualizar(true)
        }
    }, [profile, GFE, GFO, GFU, GPP]) 



    const onDrop = async files => {
        // Create an object of formData

        let hasError = false

        props.toggleDisabled(true)
        try {

            if (!isEmpty(files[0])) {
                uploadFile(setShowProgressBar, setProgress, files[0])
            }

            if (!isEmpty(files[1])) {
                uploadFile(setShowProgressBar2, setProgress2, files[1])
            }

        }
        catch (err) {
            props.toggleDisabled(false)
            toast.error(err)
            hasError = true
        } finally {
            !hasError && setCleanList(true)
        }

    }



    const uploadFile = useCallback(async (showProgress, loadProgress, file) => {
        try {

            showProgress(true)
            const formData = new FormData();
            formData.append('file', file);
            formData.append('path', file.path);
            formData.append('plei_codigo', initials.plei_codigo);


            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            await api.put('pleito/uploadanexopleitoposto', formData, {
                onUploadProgress: (event) => {
                    let progress = Math.round(
                        (event.loaded * 100) / event.total
                    );
                    //loadProgress(progress) ???
                    loadProgress(50);
                },
                headers: headers
            });
            loadProgress(100);

            toast.success(`Arquivo ${file.name} enviado com sucesso !!`)
        } catch (err) {
            toast.error(err)
        } finally {
            showProgress(false)
            loadProgress(0)
            dispatch(recordFiltering({
                ...redux.params,
                wherefield: [...redux.params.wherefield, 'plei_codigo'],
                valuewherefield: [...redux.params.valuewherefield, initials.plei_codigo],
                typewherefield: [...redux.params.typewherefield, 'EQUALS']

            }))
        }

    }, [redux])



    useEffect(() => {
        if (props.sending) {
            setFilesTemp(dropFiles)
            onDrop(dropFiles)
        }
    }, [props.sending, dropFiles])


    useEffect(() => {
        let testeArray = !isEmpty(dropFiles) && !cleanList
        if (testeArray) {
            props.toggleDisabled(false)
        } else {
            props.toggleDisabled(true)
        }
    }, [dropFiles, cleanList])


    const header = useMemo(() => [
        { id: 'plan_descritivo', label: 'Arquivos anexados' }
    ], [])

    useEffect(() => {
        return () => dispatch(resetValues())
    }, [])


    const actionButtons = useMemo(
        () => [{
            title: 'Baixar',
            action: (value) => handleDownloadAnexo(value),
            icon: <CloudDownload />,
        }]
        , [])



    const handleDownloadAnexo = useCallback(async (anexo) => {

        const resp = await api.get(`pleito/uploadanexopleitoposto/${anexo.plan_codigo}`,
            {
                responseType: 'blob',
            })

        const file = new Blob([resp.data], { type: 'application/pdf' });

        const a = document.createElement('a');
        const objectUrl = window.URL.createObjectURL(file);
        a.href = objectUrl;
        a.download = anexo.plan_descritivo.split('.')[0]
        a.click();


    }, [])


    return (
        <>
            <S.FormWrapper
                ref={reference} initialData={initials}
            >
                <Input name="plei_codigo" label="Número do Pleito:" disabled />

                {
                isADM && <Dropzone
                    onCallback={(value) => {
                        setDropFiles(value)
                        setCleanList(false)
                    }}
                    disabled={dropzoneDisabled}
                    loading={loading}
                    cleanList={cleanList} />
                }   

                {showProgressBar && <Box sx={{ width: '100%' }}>
                    <Typography >
                        Enviando Arquivo 1...
                    </Typography>
                    <LinearProgressWithLabel value={progress} />
                </Box>
                }

                {showProgressBar2 && <Box sx={{ width: '100%' }} >
                    <Typography >
                        Enviando Arquivo 2...
                    </Typography>
                    <LinearProgressWithLabel value={progress2} />
                </Box>
                }
                <UnidataTable
                    fixed
                    header={header}
                    redux={redux}
                    query={{
                        wherefield: ['plei_codigo'],
                        valuewherefield: [initials.plei_codigo],
                        typewherefield: ['EQUALS']
                    }}
                    update={false}
                    create={false}
                    delete={true}
                    remove={deletePleitoPostoAnexo}
                    keys={["plan_codigo"]}
                    detach={["plan_codigo"]}
                    read={recordFiltering}
                    actions={actionButtons}
                    title="Lista de arquivos"
                    maxHeight={300}                    

                />


            </S.FormWrapper>


        </>
    );
}

UploadPleitoPosto.propTypes = {
    reference: PropTypes.objectOf(PropTypes.any).isRequired,
    create: PropTypes.bool.isRequired,
    data: PropTypes.objectOf(PropTypes.any),
};

UploadPleitoPosto.defaultProps = {
    data: {},
};
